const standardizePath = (path: string) => {
  let standardizedPath = path;

  if (standardizedPath.startsWith('/')) {
    standardizedPath = standardizedPath.substring(1);
  }

  if (standardizedPath.endsWith('/')) {
    standardizedPath = standardizedPath.substring(0, standardizedPath.length - 1);
  }

  return standardizedPath;
};

export const isActive = (activePath: string) => (path: string) => {
  if (path === activePath || encodeURI(path) === activePath) {
    return true;
  }
  const activeParts = standardizePath(activePath).split('/');
  const pathParts = standardizePath(path).split('/');

  for (let i = 0; i < pathParts.length; i++) {
    if (activeParts.length <= i) {
      return false;
    }

    const activePart = activeParts[i];

    if (activePart !== pathParts[i] && activePart !== encodeURIComponent(pathParts[i])) {
      return false;
    }
  }

  return true;
};
